<div class="justup-dialog-large spec-list-dialog">
  <vl-dialog-header-export
    [exporting]="exporting()"
    (close)="dialogRef.close()"
    (export)="exportExcel()">
    Spécifications
  </vl-dialog-header-export>

  <div class="justup-dialog-content flex-col gap-16">

    <!-- Stats cards -->
    <div class="flex-row gap-8 wrap">
      <vl-radio-card mode="display" color="basic" icon="description"
                     title="Total"
                     style="flex: 1; min-width: 180px">
        <span content class="headline">{{ stats().total }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="warn" icon="edit"
                     title="Rédigées"
                     style="flex: 1; min-width: 160px">
        <span content class="headline">{{ stats().redigees }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="valid" icon="check_circle"
                     title="Validées"
                     style="flex: 1; min-width: 160px">
        <span content class="headline">{{ stats().validees }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="secondary" icon="schedule"
                     title="Plus récente"
                     style="flex: 1; min-width: 160px">
        <div content class="flex-col gap-2">
          <span class="body-1" style="font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
            {{ stats().mostRecentDenom }}
          </span>
          <span class="tiny" style="opacity: 0.7">
            @if (stats().mostRecentDate) {
              {{ stats().mostRecentDate | date:'dd/MM/yyyy' }}
            } @else {
              —
            }
          </span>
        </div>
      </vl-radio-card>
    </div>

    <!-- Filtres -->
    <div class="flex-row gap-8 wrap align-center">
      <div class="flex-row gap-4 wrap">
        @for (opt of subTypeOptions(); track opt.value) {
          <vl-chips
            [bubble]="opt.count"
            [contentHeight]="true"
            size="small"
            [state]="subType() === opt.value ? 'active' : 'enabled'"
            (action)="subType.set(opt.value)">
            {{ opt.name }}
          </vl-chips>
        }
      </div>
      <div class="grow"></div>
      <vl-input-search
        [(value)]="search"
        placeholder="Article, code…"
        style="min-width: 220px"
      />
    </div>

    <!-- Table -->
    <div class="spec-table-wrapper">
      <table class="spec-table">
        <thead>
          <tr>
            <th class="sortable" (click)="toggleSort('denomination')">
              Article
              @if (sortKey() === 'denomination') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable num" (click)="toggleSort('version')">
              Version
              @if (sortKey() === 'version') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable" (click)="toggleSort('etat')">
              État
              @if (sortKey() === 'etat') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th class="sortable" (click)="toggleSort('date')">
              Date
              @if (sortKey() === 'date') {
                <mat-icon class="sort-icon">{{ sortDesc() ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              }
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (row of filtered(); track row.id + ':' + row.versionNb + ':' + row.etat) {
            <tr class="row" (click)="onSelect(row)" tabindex="0"
                (keydown.enter)="onSelect(row)">
              <td class="article">
                <div class="article-cell">
                  <span class="article-name">{{ row.denomination }}</span>
                  @if (row.code) {
                    <span class="article-code on-disabled tiny">{{ row.code }}</span>
                  }
                </div>
              </td>
              <td class="num">v{{ row.versionNb ?? '—' }}</td>
              <td>
                <span class="etat-chip"
                      [class.etat-redigee]="row.etat === 'REDIGEE'"
                      [class.etat-validee]="row.etat === 'VALIDEE'">
                  {{ etatLabel(row.etat) }}
                </span>
              </td>
              <td>
                @if (row.date) {
                  {{ row.date | date:'dd/MM/yyyy' }}
                } @else {
                  —
                }
              </td>
              <td class="action">
                <mat-icon class="on-accent">arrow_forward</mat-icon>
              </td>
            </tr>
          } @empty {
            <tr><td colspan="5" class="empty">{{ 'list.empty' | trans }}</td></tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
